import { useState, useEffect } from 'react';
import './AddOrders.css';
import { addOrder } from '../../services/orderService';
import CommonMessage from '../../common/CommonMessage';
import { calculateTotals } from '../../services/calculateTotals';
import { validateOrderForm } from '../../services/orderValidation';
import { GetUserDetailsByRoleId } from '../../services/userService';
import CDropdown from '../../common/CDropdown';
import { useAppData } from '../../context/AppDataProvider';
//import { validateDropdown } from '../../utils/ValidateMobile';

const AddOrders = () => {
    const [submitting, setSubmitting] = useState(false);
    const userid = localStorage.getItem("userid");
    const userPermissionRoleId = localStorage.getItem("userPermissionRoleId");
    const INITIAL_ITEM = {
        productName: "",
        price: 0,
        quantity: 1,
        amount: 0,
    };

    const INITIAL_VALUES = {
        fName: "",
        lName: "",
        address: "",
        address1: "",
        landMark: "",
        email: "",
        mobileNo: "",
        state: "",
        city: "",
        pincode: "",
        payment: "",
        teleCallName: "",
        issueDisease: "",
        subTotal: 0,
        discount: 0,
        shipping: 0,
        grandTotal: 0,
        orderItems: [INITIAL_ITEM],
    };
    const [message, setMessage] = useState("");
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState(INITIAL_VALUES);
    const [users, setUsers] = useState([]);
    const { diseases, state, product } = useAppData();
    console.log(product);
    //const [cities, setCities] = useState([]);

    const handlePincodeBlur = async () => {
        const pincode = formData.pincode;

        if (pincode?.length !== 6) return;

        try {
            const response = await fetch(
                `https://api.postalpincode.in/pincode/${pincode}`
            );

            const data = await response.json();

            if (
                data[0]?.Status === "Success" &&
                data[0]?.PostOffice?.length > 0
            ) {
                const postOffices = data[0].PostOffice;

                // Get unique city names
                // const cityList = [
                //     ...new Set(postOffices.map(x => x.District))
                // ];

                // setCities(cityList);

                const matchedState = state.find(
                    s => s.stateName.toLowerCase() ===
                        postOffices[0].State.toLowerCase()
                );
                setFormData(prev => ({
                    ...prev,
                    city: postOffices[0].District || "",
                    state: matchedState?.id || "",
                    landMark: postOffices[0].Name
                }));
            } else {
                alert("Invalid Pincode");

                // setCities([]);

                setFormData(prev => ({
                    ...prev,
                    city: "",
                    state: "",
                }));
            }
        } catch (error) {
            console.error(error);
        }
    };
    useEffect(() => {
        if (formData.pincode?.length === 6) {
            handlePincodeBlur();
        }
    }, [formData.pincode]);

    useEffect(() => {
        const fetchUsers = async () => {
            try {

                const response = await GetUserDetailsByRoleId(Number(userPermissionRoleId));

                if (
                    response?.statusCode === 200 &&
                    response?.success
                ) {

                    setUsers(response.data || []);

                } else {

                    setUsers([]);

                    setErrors((prev) => ({
                        ...prev,
                        form:
                            response?.message ||
                            "Failed to fetch users",
                    }));
                }

            } catch (err) {

                console.error(err);

                setUsers([]);

                setErrors((prev) => ({
                    ...prev,
                    form:
                        err.message ||
                        "Something went wrong",
                }));
            }
        };

        fetchUsers();

    }, [userPermissionRoleId]);


    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => {
            let updatedData = {
                ...prev,
                [name]: value,
            };

            // recalculate total if discount/shipping changes
            if (name === "discount" || name === "shipping") {
                const totals = calculateTotals(
                    prev.orderItems,
                    name === "discount" ? value : prev.discount,
                    name === "shipping" ? value : prev.shipping
                );

                updatedData = {
                    ...updatedData,
                    ...totals,
                };
            }

            return updatedData;
        });

        setErrors((prev) => ({
            ...prev,
            [name]: "",
        }));
    };
    const handleItemChange = async (index, e) => {
        const { name, value } = e.target;

        // Update the changed field
        setFormData((prev) => {
            const items = [...prev.orderItems];

            items[index] = {
                ...items[index],
                [name]: value,
            };

            // Recalculate amount for price/qty changes
            if (name !== "productId") {
                items[index].amount =
                    Number(items[index].price || 0) *
                    Number(items[index].quantity || 0);
            }

            const totals = calculateTotals(
                items,
                prev.discount,
                prev.shipping
            );

            return {
                ...prev,
                orderItems: items,
                ...totals,
            };
        });

        // Fetch price when product changes

       if (name === "productName" && value) {
    const selectedProduct = product.find(
        (p) => p.id === Number(value)
    );

    if (selectedProduct) {
        setFormData((prev) => {
            const items = [...prev.orderItems];

            items[index] = {
                ...items[index],
                productName: value,
                productId: selectedProduct.id,
                price: selectedProduct.originPrice,
            };

            items[index].amount =
                Number(items[index].price) *
                Number(items[index].quantity);

            const totals = calculateTotals(
                items,
                prev.discount,
                prev.shipping
            );

            return {
                ...prev,
                orderItems: items,
                ...totals,
            };
        });
    }
}
    };
    const addProductRow = () => {
        setFormData((prev) => ({
            ...prev,
            orderItems: [...prev.orderItems, INITIAL_ITEM],
        }));
    };
    const removeProductRow = (index) => {
        if (formData.orderItems.length === 1) return;

        setFormData(prev => {
            const updatedItems = prev.orderItems.filter(
                (_, i) => i !== index
            );

            const totals = calculateTotals(
                updatedItems,
                prev.discount,
                prev.shipping
            );

            return {
                ...prev,
                orderItems: updatedItems,
                ...totals
            };
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // Prevent multiple clicks
        if (submitting) return;
        setMessage("");

        const validationErrors = validateOrderForm(formData);
        console.log(validationErrors);
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const payload = {
            firstName: formData.fName,
            lastName: formData.lName,
            email: formData.email,
            mobile: formData.mobileNo,
            address: formData.address,
            address2: formData.address1,
            landMark: formData.landMark,
            state: Number(formData.state),
            city: formData.city,
            postalCode: formData.pincode,
            discount: Number(formData.discount || 0),
            shipping: Number(formData.shipping || 0),
            gTotal: Number(formData.grandTotal || 0),
            paymentTypeId: Number(formData.payment),
            issueDiseaseId: Number(formData.issueDisease),
            userId: Number(userid),
            assignTo: Number(formData.teleCallName),
            items: (formData.orderItems || []).map((item, index) => ({
                productName: item.productName,
                quantity: Number(item.quantity || 0),
                priceAtPurchase: Number(item.price || 0),
                totalPrice: Number(item.amount || 0),
            })),
        };
        console.log("order Data", payload);
        try {
            setSubmitting(true);
            const response = await addOrder(payload);

            if (response?.statusCode === 200) {
                setMessage("Order saved successfully");
                setFormData({
                    ...INITIAL_VALUES,
                    orderItems: [{ ...INITIAL_ITEM }]
                });
                setErrors({});
            } else {
                setMessage("Failed to save order");
            }
        } catch (err) {
            console.error(err);
            setMessage("Something went wrong");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="container-fluid py-3">
            {/* Header */}
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h4>Order Punch</h4>
            </div>

            {/* Search Section  */}
            <div className="row mb-3">
                <div className="col-lg-6">
                    <div className="custom-card border border-warning">
                        <div className="card-header-orange">
                            Find Consignee Details
                        </div>
                        <div className="card-body-custom">
                            <input type="text"
                                className="form-control"
                                placeholder="Enter Mobile Number" />
                        </div>
                    </div>
                </div>
            </div>
            {/* {message && <CommonMessage text={message} />} */}
            <form onSubmit={handleSubmit}>
                {/* Main Section */}
                <div className="row">

                    {/* Left Side */}
                    <div className="col-lg-5">

                        <div className="custom-card">

                            <div className="card-header-red">
                                Consignee Details
                            </div>

                            <div className="card-body-custom">
                                <div className="row">

                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">
                                            First Name <span className="text-danger">*</span>
                                        </label>

                                        <input type="text" name="fName" className="form-control"
                                            value={formData.fName} maxLength={25} onChange={handleChange} />
                                        {errors.fName && (
                                            <div className="text-danger">
                                                {errors.fName}
                                            </div>
                                        )}
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">
                                            Last Name <span className="text-danger"></span>
                                        </label>

                                        <input type="text" name="lName" className="form-control"
                                            value={formData.lName} maxLength={25} onChange={handleChange} />
                                    </div>

                                </div>

                                {/* Address  */}
                                <div className="mb-3">
                                    <label className="form-label">
                                        Address 1 <span className="text-danger">*</span>
                                    </label>

                                    <textarea className="form-control" name="address" value={formData.address}
                                        maxLength={80} rows="2" onChange={handleChange}></textarea>
                                    {errors.address && (
                                        <div className="text-danger">
                                            {errors.address}
                                        </div>
                                    )}
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">
                                        Address 2 <span className="text-danger"></span>
                                    </label>

                                    <textarea className="form-control" name="address1" value={formData.address1}
                                        maxLength={80} rows="2" onChange={handleChange}></textarea>

                                </div>
                                {/* Landmark  */}
                                <div className="mb-3">
                                    <label className="form-label">
                                        Landmark
                                    </label>

                                    <input type="text" name="landMark" className="form-control" value={formData.landMark} maxLength={160} onChange={handleChange} />
                                </div>
                                {/* Email + Mobile */}
                                <div className="row">

                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">
                                            Email
                                        </label>

                                        <input type="text"
                                            name="email"
                                            className="form-control"
                                            value={formData.email}
                                            maxLength={100}
                                            onChange={handleChange}
                                        />
                                        {errors.email && (
                                            <div className="text-danger">
                                                {errors.email}
                                            </div>
                                        )}
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">
                                            Mobile No <span className="text-danger">*</span>
                                        </label>

                                        <input
                                            type="text"
                                            name="mobileNo"
                                            value={formData.mobileNo}
                                            onChange={(e) =>
                                                handleChange({
                                                    target: {
                                                        name: "mobileNo",
                                                        value: e.target.value.replace(/\D/g, "")
                                                    }
                                                })
                                            }
                                        />
                                        {errors.mobileNo && (
                                            <div className="text-danger">
                                                {errors.mobileNo}
                                            </div>
                                        )}
                                    </div>

                                </div>
                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">
                                            Payment Type <span className="text-danger">*</span>
                                        </label>

                                        {/* Dropdown */}
                                        <select
                                            name="payment"
                                            className="form-select mb-2"
                                            value={formData.payment}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select Payment</option>
                                            <option value="1">COD</option>
                                            <option value="2">Prepaid</option>
                                        </select>
                                        {errors.payment && (
                                            <div className="text-danger">
                                                {errors.payment}
                                            </div>
                                        )}
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">
                                            Pincode <span className="text-danger">*</span>
                                        </label>

                                        <input type="text"
                                            name="pincode"
                                            className="form-control"
                                            value={formData.pincode}
                                            maxLength={6} minLength={6}
                                            onChange={handleChange}
                                            onBlur={handlePincodeBlur} />
                                        {errors.pincode && (
                                            <div className="text-danger">
                                                {errors.pincode}
                                            </div>
                                        )}
                                    </div>



                                </div>
                                {/* State + City */}
                                <div className="row">

                                    <div className="col-md-6 mb-3">
                                        <CDropdown
                                            label="State"
                                            name="state"
                                            value={formData.state}
                                            options={state}
                                            optionLabel="stateName"
                                            optionValue="id"
                                            onChange={handleChange}
                                            error={errors.state}
                                            firstOption="Select State"
                                            className="col-md-8 mb-4"
                                            required={true}
                                        />

                                        {/* <label className="form-label">
                                            State <span className="text-danger">*</span>
                                        </label>

                                        <select
                                            name="state"
                                            className="form-select mb-2"
                                            value={formData.state}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select State</option>
                                            <option value="1">Delhi</option>
                                            <option value="2">UP</option>
                                        </select>
                                        {errors.state && (
                                            <div className="text-danger">
                                                {errors.state}
                                            </div>
                                        )} */}
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <label className="form-label">
                                            City <span className="text-danger">*</span>
                                        </label>

                                        <input type="text"
                                            name="city"
                                            className="form-control"
                                            value={formData.city}
                                            onChange={handleChange} />
                                        {errors.city && (
                                            <div className="text-danger">
                                                {errors.city}
                                            </div>
                                        )}
                                        {/* <select
                                            name="city"
                                            className="form-select"
                                            value={formData.city}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select City</option>

                                            {cities.map((city, index) => (
                                                <option key={index} value={city}>
                                                    {city}
                                                </option>
                                            ))}
                                        </select> */}
                                    </div>

                                </div>





                            </div>

                        </div>

                    </div>

                    {/* Right Side  */}
                    <div className="col-lg-7">

                        <div className="custom-card">

                            <div className="card-header-red">
                                Product Details
                            </div>

                            <div className="card-body-custom">
                                {/* <div className="row"> */}

                                <div className="mb-4">

                                    <CDropdown
                                        label="Tele Caller Name"
                                        name="teleCallName"
                                        value={formData.teleCallName}
                                        options={users}
                                        optionLabel="userName"
                                        optionValue="id"
                                        onChange={handleChange}
                                        error={errors.teleCallName}
                                        firstOption="Select Name"
                                        className="col-md-8 mb-4"
                                        required={true}
                                    />

                                </div>
                                {/* Dropdown  */}
                                <div className="mb-4">
                                    <CDropdown
                                        label="Select Issues"
                                        name="issueDisease"
                                        value={formData.issueDisease}
                                        options={diseases}
                                        optionLabel="name"
                                        optionValue="id"
                                        onChange={handleChange}
                                        error={errors.issueDisease}
                                        firstOption="Select Issues"
                                        className="col-md-8 mb-4"
                                        required={true}
                                    />


                                </div>



                                {/* Product Table */}
                                <div className="table-responsive">

                                    <table className="table table-bordered align-middle">

                                        <thead className="table-light">
                                            <tr>
                                                <th style={{ width: "50px" }}>#</th>
        <th style={{ width: "30%" }}>Product</th>
        <th style={{ width: "200px" }}>Price</th>
        <th style={{ width: "120px" }}>Quantity</th>
        <th style={{ width: "140px" }}>Amount</th>
                                                <th width="80">
                                                    {/* <button className="btn btn-add btn-sm">
                                                        <i className="bi bi-plus-lg"></i>
                                                    </button> */}
                                                    <button
                                                        type="button"
                                                        className="btn btn-add btn-sm"
                                                        onClick={addProductRow}
                                                    >
                                                        +
                                                    </button>
                                                </th>
                                            </tr>
                                        </thead>

                                        <tbody>

                                            {formData.orderItems.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>

                                                    <td>
                                                        <CDropdown
                                                            name="productName"
                                                            value={item.productName}
                                                            options={product}
                                                            optionLabel="name"
                                                            optionValue="id"
                                                            onChange={(e) => handleItemChange(index, e)}
                                                            firstOption="Select Product"
                                                        />
                                                    </td>

                                                    <td>
                                                        <input
                                                            type="number"
                                                            name="price"
                                                            value={item.price}
                                                            readOnly
        className="form-control"
                                                        />
                                                    </td>

                                                    <td className="price-qty">
                                                        <input
                                                            type="number"
                                                            name="quantity"
                                                            value={item.quantity}
                                                            onChange={(e) => handleItemChange(index, e)}
                                                            className="form-control"
                                                        />
                                                    </td>

                                                    <td className="price-amt">
                                                        <input
                                                            type="text"
                                                            name="amount"
                                                            value={item.amount}
                                                            readOnly
                                                            className="form-control"
                                                        />
                                                    </td>

                                                    <td className="text-center">
                                                        {formData.orderItems.length > 1 && (
                                                            <button
                                                                type="button"
                                                                className="btn btn-remove btn-sm"
                                                                onClick={() => removeProductRow(index)}
                                                            >
                                                                X
                                                            </button>
                                                        )}

                                                    </td>
                                                </tr>
                                            ))}

                                            {/* Sub Total */}
                                            <tr>
                                                <td colSpan="4"
                                                    className="text-end fw-bold">
                                                    Sub Total
                                                </td>

                                                <td>
                                                    <input
                                                        type="text"
                                                        name="subTotal"
                                                        value={formData.subTotal}
                                                        readOnly
                                                        className="form-control"

                                                    />
                                                </td>

                                                <td></td>
                                            </tr>

                                            {/* Discount  */}
                                            <tr>
                                                <td colSpan="4"
                                                    className="text-end">
                                                    Discount
                                                </td>

                                                <td>
                                                    <input
                                                        type="number"
                                                        name="discount"
                                                        value={formData.discount}
                                                        onChange={handleChange}
                                                        className="form-control"
                                                    />
                                                </td>

                                                <td></td>
                                            </tr>
                                            {/* Shipping  */}
                                            <tr>
                                                <td colSpan="4"
                                                    className="text-end">
                                                    Shipping
                                                </td>

                                                <td>
                                                    <input
                                                        type="number"
                                                        name="shipping"
                                                        value={formData.shipping}
                                                        onChange={handleChange}
                                                        className="form-control"
                                                    />
                                                </td>

                                                <td></td>
                                            </tr>



                                            {/* <Grand Total  */}
                                            <tr>
                                                <td colSpan="4"
                                                    className="text-end fw-bold">
                                                    Grand Total
                                                </td>

                                                <td>
                                                    <input
                                                        type="text"
                                                        name="grandTotal"
                                                        value={formData.grandTotal}
                                                        readOnly
                                                        className="form-control"
                                                    />
                                                </td>

                                                <td></td>
                                            </tr>

                                        </tbody>

                                    </table>

                                </div>

                                {/* Submit Button  */}
                                <div className="text-end mt-3">
                                    {/* <button className="btn btn-primary px-4">
                                        Submit Order
                                    </button> */}

                                    <button
                                        type="submit"
                                        className="btn btn-primary px-4"
                                        disabled={submitting}
                                    >
                                        {submitting ? (
                                            <>
                                                <span
                                                    className="spinner-border spinner-border-sm me-2"
                                                    role="status"
                                                    aria-hidden="true"
                                                ></span>
                                                Submitting...
                                            </>
                                        ) : (
                                            "Submit Order"
                                        )}
                                    </button>
                                </div>

                            </div>
                            {message && <CommonMessage text={message} />}
                        </div>

                    </div>

                </div>
            </form>

        </div>
    );
};
export default AddOrders;